import { api } from '../api';
import { useQuery, UseQueryResult } from 'react-query';
import { JournalMetadata, JournalOverview } from '../types/journal';

export type GetJournalsResponse = {
    journals?: JournalOverview[];
    totalItems?: number;
    metadata?: JournalMetadata;
    lastRefreshedAt?: Date;
};

type JournalQueryParams = {
    metadata?: boolean;
    page?: number;
    limit?: number;
    search?: string;
    sort?: string;
    filter?: string;
    searchFilters?: string;
};

async function getJournals(workpaperId: string, params: JournalQueryParams): Promise<GetJournalsResponse> {
    const { data } = await api.get(`/workpapers/${workpaperId}/journals?${params.filter}&${params.searchFilters}&${params.sort}`, {
        params: {
            metadata: params?.metadata,
            page: params?.page,
            limit: params?.limit,
            search: params?.search,
        },
    });
    return data;
}

export function useJournals(workpaperId: string, params: JournalQueryParams = {}): UseQueryResult<GetJournalsResponse, unknown> {
    return useQuery(['journals', workpaperId, ...Object.values(params)], () => getJournals(workpaperId, params), {
        keepPreviousData: true,
        retry: false,
    });
}
